import Vue from 'vue'
import { IUser } from '../../model/user'
import { IComment } from '../../model/comment'
import { IConvo } from '../../model/convo'
import convoStore from '../../store/convo/convo-store'
import commentStore from '../../store/comment/comment-store'
import userStore from '../../store/user/user-store'
import feedStore from '../../store/feed/feed-store'
import { IStatement } from '../../model/statement'

export default class ConvoComponent extends Vue {
  get convos () { return convoStore.state.convos }
  get convoForm () { return convoStore.state.convoForm }
  get convoSearchForm () { return convoStore.state.convoSearchForm }

  protected addConvo (): void {
    convoStore.dispatchAddConvo()
  }

  protected addFormTag (): void {
    convoStore.commitAddTagToForm({ })
  }

  protected removeFormTag (tag: string): void {
    convoStore.commitRemoveTagFromForm({ tag: tag })
  }

  protected addFormReference (): void {
    convoStore.commitAddReferenceToForm({ })
  }

  protected removeFormReference (index: number): void {
    convoStore.commitRemoveReferenceFromForm({ index: index })
  }

  protected findConvos (): void {
    convoStore.dispatchSetConvoQuery()
  }

  protected likeConvo (convo: IConvo): void {
    convoStore.dispatchLikeConvo(convo)
  }

  protected unlikeConvo (convo: IConvo): void {
    convoStore.dispatchUnlikeConvo(convo)
  }

  protected followConvo (convo: IConvo): void {
    convoStore.dispatchFollowConvo(convo)
  }

  protected unfollowConvo (convo: IConvo): void {
    convoStore.dispatchUnfollowConvo(convo)
  }

  protected addComment (convo: IConvo): void {
    convoStore.dispatchAddComment(convo)
  }

  protected likeComment (comment: IComment): void {
    commentStore.dispatchLikeComment(comment)
  }

  protected unlikeComment (comment: IComment): void {
    commentStore.dispatchUnlikeComment(comment)
  }

  protected followUser (user: IUser): void {
    userStore.dispatchFollowUser(user)
  }

  protected unfollowUser (user: IUser): void {
    userStore.dispatchUnfollowUser(user)
  }

  protected viewStatements (): void {
    feedStore.dispatchViewStatements()
  }

  protected newConvo (): void {
    feedStore.dispatchNewConvo()
  }

  protected jybeStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchJybeStatement({ statement: statement, convo: convo })
  }

  protected unjybeStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchUnjybeStatement({ statement: statement, convo: convo })
  }

  protected considerStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchConsiderStatement({ statement: statement, convo: convo })
  }

  protected unconsiderStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchUnconsiderStatement({ statement: statement, convo: convo })
  }

  protected ignoreStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchIgnoreStatement({ statement: statement, convo: convo })
  }

  protected unignoreStatement (statement: IStatement, convo: IConvo): void {
    convoStore.dispatchUnignoreStatement({ statement: statement, convo: convo })
  }
}
